import React from 'react';
import { apiEndpoint } from "helpers/url_helper";

import MetaTags from 'react-meta-tags';
// import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react"

import { connect } from "react-redux";

import {
  Card,
  CardBody,
  Col,
  Row,
  CardTitle,
  FormGroup,
  Form,
  Button,
  UncontrolledTooltip,
  CardSubtitle,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert,
  CardImg,


} from "reactstrap"

import Select from "react-select";
import { Stage, Layer, RegularPolygon, Image, Line, Shape } from 'react-konva';
import ReactBSAlert from "react-bootstrap-sweetalert";



//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";
import { useEffect } from 'react';
import { useState, useRef  } from 'react';
import Base from 'antd/es/typography/Base';


 function AddDraggableZoneConfigDetails(props) {
    const POINT_CLICK_THRESHOLD = 10; // Adjust as needed

    const breadcrumbItems = [
      { title: "Settings", link: "#" },
      { title: "Zone Configuration", link: "/ZoneConfig" },
    ];
  
    useEffect(() => {
      props.setBreadcrumbItems('Zone Configuration', breadcrumbItems);
    })
  
    const [SelectedCampusValue, setSelectedCampusValue] = useState(1);
    const [CampsuList, setCampusList] = useState([]);
    const [modal_small, setmodal_small] = useState(false);
  
    const [basic, setbasic] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [Base64CompanyLogo, setBase64CompanyLogo] = useState();
    const [showChallanPreview, setShowChallanPreview] = useState(false);
    const [showZoneConfigImage, setShowZoneConfigImage] = useState(false);
    const [coordinates, setCoordinates] = useState({ x: 0, y: 0 });
    const [startCoordinates, setStartCoordinates] = useState(null);
    const [textBoxValue, setTextBoxValue] = useState('');
    const [polyCoordinates, setPolyCoordinates] = useState([]);
    const [circleCoordinates, setCircleCoordinates] = useState([]);
    const [alertmsg, setAlert] = useState();
    const [showSavedImage, setShowSavedImage] = useState();
    const [showUpdatedImage, setShowUpdatedImage] = useState(false);



    const [imageUrl, setImageUrl] = useState(null);

    const [coordinatesSaved, setCoordinatesSaved] = useState(false);

  

    const [Campusitems, setCampusItems] = useState([]);
    const [SelectedCampusitem, setSelectedCampusItem] = useState([]);
    const [selectedCampusVal, setCampusSelected] = useState();

    var EncodedLogo = '';

    const [selectedImage, setSelectedImage] = useState(null);


    const [image, setImage] = useState(null);
    const [imageLoaded, setImageLoaded] = useState(false);
    const [points, setPoints] = useState([]);
    const [isPolygonClosed, setIsPolygonClosed] = useState(false);
    const [showStartingPoint, setShowStartingPoint] = useState(false);
    const stageRef = useRef(null);

  




    const tog_small = () => {
        debugger;
        setmodal_small(!modal_small)
        document.body.classList.add("no_padding")
      }
    
    // const PolyCoordinates = [
    //   { x: 100, y: 10 },
    //   { x: 170, y: 100 },
    //   { x: 40, y: 90 },
    // {x:190, y:56}
    // ];
    useEffect(() => {

          // UserValidated
          fetch(apiEndpoint+"/GetLogCampusList",{
            method:"POST",
            headers: {
              'Content-Type': 'application/json',
              //'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify({
              "strToken": sessionStorage.getItem("Clear_AuthUser")
              
            })

          })
              .then(res => res.json())
              .then(
                (result) => {
                  if (result != undefined) {
                    //sessionStorage.setItem("authUser",JSON.stringify(result.strNewToken))
                    //console.log(result);
                    //console.log(JSON.parse(result.CampusList));
                    if (result.CampusList != undefined) {
                      setCampusItems(JSON.parse(result.CampusList));
                      var campuslst = JSON.parse(result.CampusList);
                      setSelectedCampusItem(campuslst[0]);
                      setCampusSelected(campuslst[0].value);
                      changeCampusSelectHandler(campuslst[0]);
                      GetLocationList(campuslst[0].value);
                   }
                  }
                  },
                  // Note: it's important to handle errors here
                  // instead of a catch() block so that we don't swallow
                  // exceptions from actual bugs in components.
                  (error) => {
                      //console.log(error);
                      // /setError(error);
                  }
              )
          
      }, [])
     
      const [Locitems, setLocItems] = useState([]);
      const [SelectedLocitem, setSelectedLocItem] = useState([]);
      const [selectedLocVal, setLocSelected] = useState();

      const GetLocationList= (CampusVal) => {
        debugger;
          // UserValidated
          fetch(apiEndpoint+"/GetLogLocationList",
            {
              method:"POST",
              headers: {
                'Content-Type': 'application/json',
                //'Access-Control-Allow-Origin': '*',
              },
              body: JSON.stringify({
                "strToken": sessionStorage.getItem("Clear_AuthUser"),
                "intCampusID": CampusVal
                
              })
  
            })
              .then(res => res.json())
              .then(
                  (result) => {
                    debugger;
                  if (result != undefined) {
                    //sessionStorage.setItem("authUser",JSON.stringify(result.strNewToken))
                    if (result.Locations != undefined && result.Locations != "null") {
                      debugger;
                      var locArr = JSON.parse(result.Locations);
                      locArr.push({ "value": 0, "label": "All" })
                      setLocItems(locArr);
  
                      var loclst = JSON.parse(result.Locations);
                      setSelectedLocItem(loclst[0]);
                      setLocSelected(loclst[0].value);
                      GetZoneConfigDetails( CampusVal,loclst[0].value);

                    
                    }
                    else{
                      setLocItems();
                      setSelectedLocItem();

                    }
                  }
                },
                  // Note: it's important to handle errors here
                  // instead of a catch() block so that we don't swallow
                  // exceptions from actual bugs in components.
                  (error) => {
                      //console.log(error);
                      // /setError(error);
                  }
              )
      }



      const changeCampusSelectHandler = (event) => {
        debugger;
          setSelectedCampusItem(event);
          setCampusSelected(event.value);
          GetLocationList(event.value);
         
      };
  
      const changeLocSelectHandler = (event) => {
        debugger;
          setSelectedLocItem(event);
          setLocSelected(event.value);
          GetZoneConfigDetails( selectedCampusVal,event.value);
          
        
      };
    
  
      const [SelectedZoneSideItems, setSelectedZoneSideItems] = useState({value: 'RHS', label: 'RHS'});

      const ZoneSideItems = [
        { value: 'RHS', label: 'RHS' },
        { value: 'LHS', label: 'LHS' },
        // Add other options as needed
      ];
    
      const handleZoneSideChange = (selectedOption) => {
        setSelectedZoneSideItems(selectedOption);
      };
      const [SelectedTrafficDirection, setSelectedTrafficDirection] = useState({value: 'Incoming', label: 'Incoming'});

      const TrafficDirection = [
        { value: 'Incoming', label: 'Incoming' },
        { value: 'Outgoing', label: 'Outgoing' },
        // Add other options as needed
      ];
    
      const handleTrafficDirectionChange = (selectedOption) => {
        setSelectedTrafficDirection(selectedOption);
      };
    
      function ValidateCompanyLog(value) {
        debugger;
        const allowedTypes = ['jpeg', 'png','jpg', 'JPEG', 'PNG', 'JPG'];
        if(value != "")
        {
        
          const fileExtension = value.split('.').pop();
        
          if (!allowedTypes.includes(fileExtension)) {
            // Invalid file type
            // Set an error message or take appropriate action
            return "Please choose Image File";
          } else {
            return true;
          }
        }
       }
       const SelectCompanyLogo = (e) => {
        debugger;
        const allowedTypes = ['jpeg', 'png','jpg', 'JPEG', 'PNG', 'JPG'];
        let fileType = e.target.files[0].name.split('.');
        if(allowedTypes.includes(fileType[1]))
          {
        let files = e.target.files;
        let reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = (e) => {
            debugger;
          

           
            setBase64CompanyLogo(e.target.result);
          console.log('image data: ', e.target.result);
          EncodedLogo = e.target.result;
          const img = new window.Image();
          img.src = EncodedLogo;
          img.width = 960; // Adjust width as needed
          img.height = 540;
          img.onload = () => {
            debugger;
           
            setSelectedImage(img);
            setImageLoaded(true);
            setPoints([]);
            setIsPolygonClosed(false);
            setImageUrl(URL.createObjectURL(files[0]));

          };
    
        }
        };
        
       
      }
   

    const handleDragEnd = (index, e) => {
        const updatedPoints = [...points];
        updatedPoints[index] = { x: e.target.x(), y: e.target.y() };
        setPoints(updatedPoints);
      };
    
      const handleStageClick = (e) => {
        debugger;
        if (!isPolygonClosed) {
          const stage = e.target.getStage();
          const point = stage.getPointerPosition();
    
          if (points.length >= 2) {
            const firstPoint = points[0];
            const distance = Math.sqrt(
              (point.x - firstPoint.x) ** 2 + (point.y - firstPoint.y) ** 2
            );
    
            if (distance < POINT_CLICK_THRESHOLD) {
              setPoints([...points, points[0]]);
              setIsPolygonClosed(true);
            } else {
              setPoints([...points, { x: point.x, y: point.y }]);
            }
          } else {
            setPoints([...points,{ x: point.x, y: point.y }]);
          }
          setPoints([...points,{ x: point.x, y: point.y }]);
        }
        setShowStartingPoint(true);
      };

     
      





    

      const GetZoneConfigDetails= (CampusVal,LocVal) => {
        debugger;
        // UserValidated
        fetch(apiEndpoint+'/GetZoneConfigDetails',
      {
        mode: "cors",
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          //'Access-Control-Allow-Origin': '*',
        },
        body: JSON.stringify({
          "CampusID": CampusVal,
          "LocationID": LocVal,
          "strToken": sessionStorage.getItem("Clear_AuthUser")

        })
     }
    )
      .then(res => res.json())
      .then((data) => {
        debugger;
        if (data.ResponseType == "success") {
         debugger;
         setImageLoaded(false);
         if(data.ZoneConfig != null && data.ZoneConfig != undefined && data.ZoneROI != null)
         {
          if(data.ZoneConfig.Base64UploadedImage != null)
          {
            var base64Img = data.ZoneConfig.Base64UploadedImage;
            const img = new window.Image();
          img.src = base64Img;
          img.width = 960; // Adjust width as needed
          img.height = 540;
          img.onload = () => {
            debugger;
           
            setSelectedImage(img);
            setImageLoaded(true);
            //setImageUrl(URL.createObjectURL(files[0]));

          };
            setBase64CompanyLogo(data.ZoneConfig.Base64CompanyLogo);
          }
         }
         if(data.ZoneROI != null && data.ZoneROI != undefined && data.ZoneROI.length != 0)
         {
          setPoints(data.ZoneROI);
          setIsPolygonClosed(true);

         }
          

        }
        else if (data.ResponseType == "error") {
          setAlert(
            <ReactBSAlert
              warning
              //   style={bsAlertStyle}
              title="Something went Wrong !"
              onConfirm={() => setAlert(null)}
              onCancel={() => setAlert(null)}
              confirmBtnBsStyle="warning"
            >
            </ReactBSAlert>
          )
        }
      });
      }

      const SubmitZoneConfigDetails = () => {
        debugger;
        if(points.length >= 4 )
        {
          // UserValidated
          fetch(apiEndpoint+'/AddNewZoneConfig',
          {
            mode: "cors",
            method: "POST",
            headers: {
              'Content-Type': 'application/json',
              //'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify({
              "CampusID": selectedCampusVal,
              "LocationID": selectedLocVal,
              "ROI": points,
              "TrafficDirection":SelectedTrafficDirection.value,
              "ZoneSide": SelectedZoneSideItems.value,
              "Base64UploadedImage": Base64CompanyLogo,     
              "strToken": sessionStorage.getItem("Clear_AuthUser")
            })
         }
        )
          .then(res => res.json())
          .then((data) => {
            
            if (data.ResponseType == "success") {
             debugger;
             setCoordinatesSaved(true); 
             setShowUpdatedImage(true); 
    
              setAlert(
                <ReactBSAlert
                  success
                  //   style={bsAlertStyle}
                  
                  title="Zone Configuration Saved Succesfully!"
                  onConfirm={() => setAlert(null)}
                  onCancel={() => setAlert(null)}
                  confirmBtnBsStyle="info"
                >
                </ReactBSAlert>
              )
    
            }
            else if (data.ResponseType == "error") {
              setAlert(
                <ReactBSAlert
                  warning
                  //   style={bsAlertStyle}
                  title="Please Choose Image File and Draw Zone Coordinates !"
                  onConfirm={() => setAlert(null)}
                  onCancel={() => setAlert(null)}
                  confirmBtnBsStyle="warning"
                >
                </ReactBSAlert>
              )
            }
          });
        }
        else{
          setAlert(
            <ReactBSAlert
              warning
              //   style={bsAlertStyle}
              title="Please Choose Image File and Draw Zone Coordinates !"
              onConfirm={() => setAlert(null)}
              onCancel={() => setAlert(null)}
              confirmBtnBsStyle="warning"
            >
            </ReactBSAlert>
          )
        }
        debugger;
       
      };  

      
      const ResetZoneConfiguration = () =>{
        setPoints([]);
        setIsPolygonClosed(false);

        setPolyCoordinates([]);
        setCircleCoordinates([]);
            
      };
    
  
    const [AddNewCampusValue, setAddNewCampusValue] = useState();
  
    const [DataValues, setDataValues] = useState({ NewLatitudeValue: 18.5204, NewLongitudeValue: 73.2341 });
  
  
    return (
        <React.Fragment>
          <MetaTags>
            <title>Indus | Zone Configuration</title>
          </MetaTags>
          <Card style={{width:"100%", height:"200%"}}>
        
        <CardBody>
  
    {alertmsg}   
  <Row className="col-md-12">
    <Col md= {3}>
          <Row className="col-md-12">
        
          <Row className="col-md-12"></Row>
                  <Col md={12}>
                      <label className="mt-1" > Campus  </label>
                      <Select value={SelectedCampusitem} options={Campusitems} onChange={changeCampusSelectHandler}></Select>
                  </Col>
                  </Row>

                  <Row className="col-md-12  mt-3">
                  <Col md={12}>
                      <label className="mt-1" > Location  </label>
                      <Select value={SelectedLocitem} options={Locitems} onChange={changeLocSelectHandler}></Select>
                  </Col>
                  </Row>
                  <Row className="col-md-12 mt-3">
                  <Col md={12}>
                      <label className="mt-1" > Zone Side  </label>
                      <Select
            value={SelectedZoneSideItems}
            options={ZoneSideItems}
            onChange={handleZoneSideChange}
          ></Select>                
          </Col>
          </Row>
          <Row className="col-md-12  mt-3">

                  <Col md={12}>
                      <label className="mt-1" > Traffic Direction  </label>
                      <Select
            value={SelectedTrafficDirection}
            options={TrafficDirection}
            onChange={handleTrafficDirectionChange}
          ></Select>                     </Col> 
                  </Row>
  {/* <Row className="col-md-12">
      <br/>
     
  </Row> */}
  <Row  className="col-md-12  mt-3">
  <Col md={12}>
                      <label
                        htmlFor="example-email-input"
                        className="col-md-12 col-form-label"
                      >
                        Select Image File
                      </label>
  
                      <div className="col-md-12">
                        
                        <input type="file"
                          className="form-control form-control-file "
                          data-buttonname="btn-secondary"
                          name = "Company Logo"
                          errorMessage = "Please Add Valid File"
                          validate = {{ValidateCompanyLog}}
                          onChange={SelectCompanyLogo}
  
                        />
                      </div>
  </Col>
                    </Row>
                   <Row className="col-md-12 mt-4">
                  <Col md={6}>
  <button className="  mdi mdi-restart  btn btn-primary mdi-18px "  onClick={() => {{ResetZoneConfiguration()}
                  
                  }}> </button>

  <button className="mx-2 mdi mdi-content-save btn btn-primary mdi-18px" onClick={() => {{SubmitZoneConfigDetails()}
                  
                }}> </button>

  </Col>
                   </Row>
                    </Col>
                    <br/>
                    <Col md={6}>
                   {(selectedImage) &&  (imageLoaded) &&(
          <Stage
          width={960}
          height={540}
          onClick={handleStageClick}
          >
            <Layer>
            <Image image={selectedImage} />

            
              {points.map((point, index) => (
                <RegularPolygon
                  key={index}
                  sides={4}
                  x={point.x}
                  y={point.y}
                  radius={8}
                  fill="green" opacity={0.5} 
                    
                  draggable
                  onDragEnd={(e) => handleDragEnd(index, e)}
                />
              ))}
               {showStartingPoint && points.length > 0 && (
                <RegularPolygon
                  sides={4} 
                  x={points[0].x}
                  y={points[0].y}
                  radius={8}
                  fill="green" 
                  stroke="black"
                  strokeWidth={2}
                
                />
              )}

              
              
              <Line
                points={points.flatMap((p) => [p.x, p.y])}
                stroke="black"
              />
           { isPolygonClosed &&  <Shape
            sceneFunc={(context, shape) => {
              context.beginPath();
              context.moveTo(points[0].x, points[0].y);
              for (let i = 1; i < points.length; i++) {
                context.lineTo(points[i].x, points[i].y);
            }
             // context.lineTo(points[1].x, points[1].y);
             // context.quadraticCurveTo(points);              
              context.closePath();
              // (!) Konva specific method, it is very important

                // Set the fill color with reduced opacity (e.g., 50% opacity, blue color)
        context.fillStyle = 'rgba(255, 255, 0, 0.5)'; // Blue color with 50% opacity

        // Fill the polygon
        context.fill();

        // Stroke the shape (optional)
        context.stroke();

              context.fillStrokeShape(shape);
            }}
          //  fill="#29446b"
         //   stroke="black"
            strokeWidth={2}
          />} 
           

              
            </Layer>
          </Stage>
          )} 
          </Col>
          </Row>
                  </CardBody>
                  
          </Card>
        
      
         
    
        </React.Fragment>
    
    
    
      ) 
        
  
  }
export default connect(null, { setBreadcrumbItems })(AddDraggableZoneConfigDetails);